var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticClass:"contacts_list",attrs:{"name":"flip-list","tag":"div"}},_vm._l((_vm.data),function(item,index){return _c('ChatListItem',{key:'chat_' + item.id,attrs:{"chat":item,"disabled":_vm.disabled}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }